import React from "react";
import { Link as RouterLink } from "react-router-dom";
import BlazeAILogo from "../BlazeAILogo";
import BlazeAIBrand from "../BlazeAIBrand";

export default function BlazeAISection() {
  return (
    <section id="blaze-ai">
      <div className="wrap">
        <div className="ai-wrap">
          <div className="reveal">
            <span className="eyebrow"><BlazeAIBrand /></span>
            <h2 className="h2" style={{ marginTop: 16 }}>
              AI that knows your cloud in and out.
              <br />
              <span className="mute">Specialized agents, embedded across every workflow.</span>
            </h2>
            <p className="lead" style={{ marginTop: 16 }}>
              A suite of specialized agents woven through InfraBlaze — continuously analyzing your inventory, codifying resources, remediating drift, and authoring policy. Grounded in your cloud, not pre-trained on it.
            </p>
            <div style={{ display: "grid", gap: 12, marginTop: 24 }}>
              <div className="body">✓  Dedicated agents for codification, drift, cost, and policy</div>
              <div className="body">✓  Grounded in your live inventory — not trained on it</div>
              <div className="body">✓  Generates IaC aligned with your conventions</div>
              <div className="body">✓  BYO LLM — Anthropic, OpenAI, Bedrock, or self-hosted</div>
            </div>
            <div className="hero-cta" style={{ marginTop: 24 }}>
              <RouterLink to="/blaze-ai" className="btn btn-ghost">See <BlazeAIBrand /> in action</RouterLink>
            </div>
          </div>

          <div className="ai-demo reveal">
            <header>
              <div className="ai-avatar" aria-hidden="true">
                <BlazeAILogo size={48} isWorking showRing flameBoost={1.4} />
              </div>
              <span className="ai-tag"><BlazeAIBrand /></span>
              <span className="ai-file">resources.tf · branch: platform/refactor</span>
              <span className="ai-status"><i></i>thinking</span>
            </header>
            <div className="body-area">
              <div className="ai-input">
                <span className="chev">›</span>
                <span>
                  Import the 4 untagged buckets in <b style={{ color: "var(--ink-8)" }}>prod-data</b> and add them to the <b style={{ color: "var(--ink-8)" }}>data-lake</b> stack
                  <span className="caret"></span>
                </span>
              </div>
              <div className="ai-output">
                <div className="ai-step"><span className="ic ai">AI</span><span><b>Scanned</b> 4 buckets, 2 already referenced by other stacks.</span></div>
                <div className="ai-step"><span className="ic run">→</span><span><b>Generated</b> <code>data-lake/buckets.tf</code> · 86 LOC · tags inherited from stack defaults.</span></div>
                <div className="ai-step"><span className="ic run">→</span><span><b>Drafted</b> import blocks · imports cleanly, nothing to hand-edit.</span></div>
                <div className="ai-step"><span className="ic ok">✓</span><span><b>Plan clean.</b> 5/5 policies pass. PR opened: <code>#482 chore(data-lake): import prod buckets</code></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
